import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import * as StringUtils from 'web-app/util/string';

export default class PermissionsApi {
    static listForChild(childId) {
        return RESTClient.getAuthenticated('v2/permissions', {
            recipient: StringUtils.fromChildIdToRecipient(childId),
        });
    }

    static updatePermission(permissionReplyId, answer) {
        return RESTClient.postAuthenticated(`v2/permissions/replies/${permissionReplyId}`, {
            answer,
        });
    }

    static getPossibleRecipients(institutionId) {
        return RESTClient.getAuthenticatedObservable('v2/permissions/recipients', {
            institutionId,
        });
    }
}
